class ReactQueryBuilderAdapter
{
    public containerId: string;

    constructor(params: {
        containerId: string,
    })
    {
        this.containerId = params.containerId;
    }

    public create()
    {
        const containerDiv = document.querySelector(`#${this.containerId}`);

        const root = ReactDOM.createRoot(containerDiv);

        root.render(
            // @ts-ignore
            React.createElement(ReactQueryBuilderWrapper, {
                adapter: this,
            }, null)
        );
    }
}

export { ReactQueryBuilderAdapter };
